import React, { useState } from "react";
import Footer from "../footer/footer";
import Header from "@/components/header/header";
import MobileNav from "../mobileNav";
import Head from "next/head";
import { Toaster } from "react-hot-toast";


const Layout = ({ children, pageTitle }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="dark:bg-black">
      <Head>
        <meta
          name="description"
          content="Expert digital solutions for your business"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <title>{pageTitle}</title>

          
       
      </Head>


      <Header setOpen={setOpen} />
      <main>
        {children}
        {open && <MobileNav setOpen={setOpen} />}
        <Toaster />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;

